var styles = {"box":"ModalContentWrapper_box_17dej_1","header":"ModalContentWrapper_header_17dej_8","borderless":"ModalContentWrapper_borderless_17dej_20","title":"ModalContentWrapper_title_17dej_31","body":"ModalContentWrapper_body_17dej_41","nav-back":"ModalContentWrapper_nav-back_17dej_44"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
